import { createContext } from 'react';

export const ImportProcessingContext = createContext({
  lineId: -1,
  projectId: -1,
  templateProcessId: -1,
  refetch: () => {},
});
